import { useCappsLandlordApplicationPermissionsWebApiHandler_permissionCheck } from '@zg-rentals/ts-capps-client-react-query';
import { useGetListingAlias } from '../routes';

export function useGetLandlordPermissions() {
  const listingAlias = useGetListingAlias();
  const { data, isLoading } = useCappsLandlordApplicationPermissionsWebApiHandler_permissionCheck(
    { listingAlias },
    { enabled: !!listingAlias },
  );

  return {
    isMissingPermissions: !isLoading && data === false,
  };
}
